export const addresses = {
  eexExchange: 'EEX Exchange',
  miningExpress: 'Mining Express'
};
